import { Component, OnInit, Output, ViewChild, EventEmitter, Input, OnChanges, SimpleChanges, OnDestroy, AfterViewInit } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

export interface Evento{
  nombre: string;
  valor: any;
}

export interface Columna{
  titulo: string;
  id: string;
  ocultar: boolean;
}

@Component({
  selector: 'app-tabla-material',
  templateUrl: './tabla-material.component.html',
  styleUrls: ['./tabla-material.component.scss']
})
export class TablaMaterialComponent implements AfterViewInit, OnChanges, OnDestroy {
  
  @Input() columnas: Columna[] = [];
  @Input() filas : any[] = [];
  
  @Output() eventos = new EventEmitter<Evento>();

  @Input() config = {
    colorChecks: 'accent',
    catFilasPag: [5, 10, 25],
    filasPagina: 10
  };
  @Input() filasSeleccionadas : any[] = [];

  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource([]);
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  seleccion = new SelectionModel<any>(true, []);
  subSel = new Subscription();

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    const valUno = changes.filas ? !changes.filas.firstChange : false
    const valDos = changes.columnas ? !changes.columnas.firstChange : false
    const valTres = changes.filasSeleccionadas ? !changes.filasSeleccionadas.firstChange : false
    if (valUno || valDos) this.recuperarFilas();
    if (valTres && this.filasSeleccionadas.length || this.filas.length){
      this.filasSeleccionadas.forEach(row => this.seleccion.select(row));
    }
  }

  ngAfterViewInit(): void {
    if (this.filas.length) this.recuperarFilas();
    // setTimeout(() => this.recuperarFilas(), 500);
    this.subSel = this.seleccion.changed.pipe(debounceTime(250)).subscribe(sel => {
      
      if (this.seleccion.isEmpty()) this.emitirEv('deseleccionar-todo', []);
      if (this.isAllSelected) this.emitirEv('seleccionar-todo', [...this.dataSource.data]);
      this.emitirEv('fila-sel', this.seleccion.selected);
    });
  }

  ngOnDestroy(): void {
    this.subSel.unsubscribe();
  }

  recuperarFilas(){
    
    if (!this.columnas.length) return;
    this.displayedColumns = this.columnas.map(col => (col.id));

    const SORT = () => {
      if (this.sort) this.dataSource.sort = this.sort;
      else setTimeout(() => SORT() , 500);
    };

    const PAG = () => {
      if (!this.paginator) return setTimeout(() => PAG() , 500);
      this.dataSource.paginator = this.paginator;
      this.paginator.pageIndex = 0;
    };

    this.seleccion.clear();
    this.dataSource = new MatTableDataSource(this.filas);
   
    SORT();
    PAG();
    this.emitirEv('cargar-info', null);
    if (!this.filasSeleccionadas.length || !this.filas.length) return;
    this.filasSeleccionadas.forEach(row => this.seleccion.select(row));
  }

  emitirEv(nombre: string, valor: any){
    this.eventos.emit({nombre, valor});
  }

  get isAllSelected() {
    const numSelected = this.seleccion.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) this.dataSource.paginator.firstPage();
  }

  masterToggle() {
    this.isAllSelected ?
    this.seleccion.clear() :
    this.dataSource.data.forEach(row => this.seleccion.select(row));
  }

}
